import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';
import { CustomizedFormErrorMessage } from 'components/common';

export const CompletionPlanSegment = ({ options, isSelected, onFiltersChanged, isLoading }) => {
    const {
        control,
        watch,
        formState: { errors },
    } = useFormContext<IFields>();
    return isSelected ? (
        <>
            <div className={classes.selectWrapper}>
                <span className={classes.title}>Completion Plan Segment</span>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<string>>
                            id={'battlecards-filters-completion-plan-segment'}
                            {...field}
                            onChange={(newValue) => {
                                field.onChange(newValue);
                                onFiltersChanged({ [field.name]: newValue });
                            }}
                            options={options}
                            isError={Boolean(errors.completionPlanSegment)}
                            isClearable={true}
                            isLoading={isLoading}
                        />
                    )}
                    name={'completionPlanSegment'}
                    control={control}
                    rules={{
                        validate: {
                            activityFragnetValidation: (value) => {
                                return (
                                    !Boolean(!watch('activityFragnet') && value) ||
                                    'Completion Plan Segment filter is missing a value for Fragnet'
                                );
                            },
                        },
                    }}
                />
            </div>
            {errors.completionPlanSegment && <CustomizedFormErrorMessage text={errors.completionPlanSegment.message} />}
        </>
    ) : null;
};
